import "moment/locale/id";
import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazyUser = Loadable({
    loader: () => import("pages/User/index"),
    loading: () => <PageLoader />,
});

const LazyUserDetail = Loadable({
    loader: () => import("pages/User/Detail"),
    loading: () => <PageLoader />,
});


function UserRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazyUser />} />
            <Route path="/detail/:id" element={<LazyUserDetail />} />
        </Routes>
    );
}

export default UserRoute;
